// Shared cache utilities for the application

// Business idea cache
const businessIdeaCache = new Map<string, { data: any; timestamp: number }>();
const CACHE_DURATION = 10 * 60 * 1000; // 10 minutes

/**
 * Invalidate business idea cache for a specific user
 */
export const invalidateBusinessIdeaCache = (userId: string) => {
  const cacheKey = `businessIdea_${userId}`;
  businessIdeaCache.delete(cacheKey);
};

/**
 * Get cached business idea for a user
 */
export const getCachedBusinessIdea = (userId: string) => {
  const cacheKey = `businessIdea_${userId}`;
  const cached = businessIdeaCache.get(cacheKey);
  const now = Date.now();

  if (cached && now - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }

  return null;
};

/**
 * Set cached business idea for a user
 */
export const setCachedBusinessIdea = (userId: string, data: any) => {
  const cacheKey = `businessIdea_${userId}`;
  businessIdeaCache.set(cacheKey, { data, timestamp: Date.now() });
};
